export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f71eaa51d0ac7ceff81f53dc9bb5bcf715bd0d785&name=fetchTypeahead!'